(function($) {

	// Wait for document to get ready.
	$(document).ready(function() {

		// Get header element.
		var headerElement = document.getElementsByTagName('header');

		// If no header where found.
		if(!headerElement.length) {

			// Exit.
			return;
		}

		// Create a mutation observer.
		var loggedInObserver = new MutationObserver(function (mutations) {

			// Loop over mutations.
			mutations.forEach(function(mutation) {

				// If nodes where added.
				if(mutation.addedNodes) {

					// Indicate if looged in element where found. Default to false.
					var found = false;

					// Loop over each added node.
					for(var elementIndex in mutation.addedNodes)
					{
						//
						if(!mutation.addedNodes.hasOwnProperty(elementIndex)) {
							continue;
						}

						//
						var element = mutation.addedNodes[elementIndex];

						// If new element's id is logged-in ass.
						if(element.id === "logged-in-as") {

							// Element is found.
							found = true;

						} else {

							// Get element.
							var $element = $(element);

							// Try to find logged in element deeper.
							if($element.find('#logged-in-as').length) {

								// Mark as found.
								found = true;
							}
						}
					}

					// If element where found.
					if(found) {

						// Set logged in class on body.
						$('body').addClass('softadmin-logged-in');
					} else {
						$('body').addClass('softadmin-logged-out');
					}
				}
			});
		});

		// Setup your configuration, this will watch to see if you insert or remove any children.
		var config = {
			subtree: true,
			childList: true
		};

		// Start observing.
		loggedInObserver.observe(headerElement[0], config);

	});

})(window.jQuery);
